export default "__VITE_ASSET__DW6hg5Ev__"